<div class="p-6">
  <app-loader [show]="loading" [mainMessage]="'Updating profile'"> </app-loader>
  <!-- Profile Card -->
  <section
    class="bg-white rounded-2xl shadow-md border max-w-5xl mx-auto"
  >
    <div class="flex justify-between items-center border-b p-6">
      <h2 class="text-lg font-medium flex items-center gap-2">
        <img src="assets/icons/setting-profile.svg" alt="profile Icon" />
        {{ "DASHBOARD.SETTINGS.PROFILE" | translate }}
      </h2>
      <button
        class="flex items-center gap-2 bg-[#009689] text-white px-4 py-2 rounded-md hover:bg-[#00BBA7] transition"
        (click)="onSaveProfile(profileForm)"
      >
        <img src="assets/icons/save.svg" alt="save Icon" />
        {{ "DASHBOARD.SETTINGS.SAVE" | translate }}
      </button>
    </div>

    <!-- Profile Form with Validation -->
    <form
      #profileForm="ngForm"
      class="grid grid-cols-1 md:grid-cols-2 gap-4 p-6"
      (ngSubmit)="onSaveProfile(profileForm)"
    >
      <!-- Your Name -->
      <div>
        <label class="text-sm font-medium text-gray-600">
          {{ "DASHBOARD.SETTINGS.YOUR_NAME" | translate }} *
        </label>
        <input
          type="text"
          [(ngModel)]="yourName"
          name="yourName"
          required
          #yourNameRef="ngModel"
          [placeholder]="
            'DASHBOARD.SETTINGS.PLACEHOLDERS.YOUR_NAME' | translate
          "
          class="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-teal-500 focus:border-teal-500"
        />
        <div
          *ngIf="
            (yourNameRef.touched || profileForm.submitted) &&
            yourNameRef.invalid
          "
          class="text-red-500 text-sm mt-1"
        >
          <span *ngIf="yourNameRef.errors?.['required']">Name is required</span>
        </div>
      </div>

      <!-- National ID -->
      <div>
        <label class="text-sm font-medium text-gray-600">
          {{ "DASHBOARD.SETTINGS.NATIONAL_ID" | translate }} *
        </label>
        <input
          type="text"
          [(ngModel)]="nationalId"
          name="nationalId"
          pattern="^[0-9]+$"
          maxlength="20"
          [placeholder]="
            'DASHBOARD.SETTINGS.PLACEHOLDERS.NATIONAL_ID' | translate
          "
          required
          #nationalIdRef="ngModel"
          class="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-teal-500 focus:border-teal-500"
        />
        <div
          *ngIf="
            (nationalIdRef.touched || profileForm.submitted) &&
            nationalIdRef.invalid
          "
          class="text-red-500 text-sm mt-1"
        >
          <span *ngIf="nationalIdRef.errors?.['required']"
            >National ID Number is required</span
          >
          <span *ngIf="nationalIdRef.errors?.['pattern']"
            >Only numeric values are allowed</span
          >
          <span *ngIf="nationalIdRef.errors?.['maxlength']"
            >National ID cannot exceed 20 digits</span
          >
        </div>
      </div>

      <!-- Email -->
      <div>
        <label class="text-sm font-medium text-gray-600">
          {{ "DASHBOARD.SETTINGS.EMAIL_ADDRESS" | translate }} *
        </label>
        <input
          type="email"
          [(ngModel)]="email"
          name="email"
          required
          email
          #emailRef="ngModel"
          [placeholder]="
            'DASHBOARD.SETTINGS.PLACEHOLDERS.EMAIL_ADDRESS' | translate
          "
          class="mt-1 w-full border rounded-md px-3 pr-10 py-2 focus:outline-none focus:ring-teal-500 focus:border-teal-500"
        />
        <div
          *ngIf="
            (emailRef.touched || profileForm.submitted) && emailRef.invalid
          "
          class="text-red-500 text-sm mt-1"
        >
          <span *ngIf="emailRef.errors?.['required']">Email is required</span>
          <span *ngIf="emailRef.errors?.['email']"
            >Enter a valid email address</span
          >
        </div>
      </div>

      <!-- Mobile Number -->
      <div>
        <label class="text-sm font-medium text-gray-600">
          {{ "DASHBOARD.SETTINGS.MOBILE_NUMBER" | translate }} *
        </label>
        <input
          type="text"
          [(ngModel)]="mobileNumber"
          name="mobileNumber"
          pattern="^[0-9]+$"
          minlength="10"
          maxlength="15"
          required
          #mobileNumberRef="ngModel"
          [placeholder]="
            'DASHBOARD.SETTINGS.PLACEHOLDERS.MOBILE_NUMBER' | translate
          "
          class="mt-1 w-full border rounded-md px-3 pr-10 py-2 focus:outline-none focus:ring-teal-500 focus:border-teal-500"
        />

        <div
          *ngIf="
            (mobileNumberRef.touched || profileForm.submitted) &&
            mobileNumberRef.invalid
          "
          class="text-red-500 text-sm mt-1"
        >
          <span *ngIf="mobileNumberRef.errors?.['required']">
            Mobile number is required
          </span>
          <span
            *ngIf="
            mobileNumberRef.errors?.['minlength'] ||
            mobileNumberRef.errors?.['maxlength'] ||
            mobileNumberRef.errors?.['pattern']
          "
          >
            Enter a valid mobile number
          </span>
        </div>
      </div>
    </form>
  </section>

  <!-- Change Password Card -->
  <section
    class="bg-white rounded-2xl shadow-md border mt-6 max-w-5xl mx-auto"
  >
    <div class="flex justify-between items-center p-6">
      <div class="flex items-center gap-2">
        <img
          src="assets/icons/setting-change-password.svg"
          alt="change password Icon"
        />
        <span class="text-lg font-medium text-black">
          {{ "DASHBOARD.SETTINGS.CHANGE_PASSWORD" | translate }}
        </span>
      </div>

      <button
        (click)="toggleChangePassword()"
        class="flex items-center gap-2 border px-4 py-2 rounded-md hover:bg-orange-50 transition"
      >
        <img src="assets/icons/lock.svg" alt="lock Icon" />
        {{ "DASHBOARD.SETTINGS.CHANGE_PASSWORD" | translate }}
      </button>
    </div>

    <!-- Toggle Password Fields -->
    <div *ngIf="isChangePasswordActive" class="p-6 border-t pt-6">
      <form #passwordForm="ngForm" (ngSubmit)="onSendOtp(passwordForm)">
        <div class="flex flex-wrap justify-between gap-4">
          <!-- Current Password -->
          <div class="w-full md:w-[31%] relative">
            <label
              for="currentPassword"
              class="block text-sm font-medium text-gray-700 mb-1"
              >{{ "DASHBOARD.SETTINGS.CURRENT_PASSWORD" | translate }}</label
            >
            <div class="relative">
              <input
                [type]="showCurrentPassword ? 'text' : 'password'"
                id="currentPassword"
                name="currentPassword"
                [(ngModel)]="currentPassword"
                required
                [disabled]="isOtpSent"
                #currentPasswordRef="ngModel"
                class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100 disabled:text-gray-500"
              />
              <!-- Eye icon -->
              <button
                type="button"
                (click)="togglePasswordVisibility('current')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 focus:outline-none"
              >
                <img
                  *ngIf="!showCurrentPassword"
                  src="assets/icons/eye.svg"
                  alt="eye icon"
                />
                <img
                  *ngIf="showCurrentPassword"
                  src="assets/icons/eye-slash.svg"
                  alt="eye-slash icon"
                />
              </button>
            </div>
            <div
              *ngIf="
                (currentPasswordRef.touched || passwordForm.submitted) &&
                currentPasswordRef.invalid
              "
              class="text-red-500 text-sm mt-1"
            >
              Current password is required
            </div>
          </div>

          <!-- New Password -->
          <div class="w-full md:w-[31%] relative">
            <label
              for="newPassword"
              class="block text-sm font-medium text-gray-700 mb-1"
              >{{ "DASHBOARD.SETTINGS.NEW_PASSWORD" | translate }}</label
            >
            <div class="relative">
              <input
                [type]="showNewPassword ? 'text' : 'password'"
                id="newPassword"
                name="newPassword"
                [(ngModel)]="newPassword"
                required
                [disabled]="isOtpSent"
                #newPasswordRef="ngModel"
                class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100 disabled:text-gray-500"
              />
              <button
                type="button"
                (click)="togglePasswordVisibility('new')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                <img
                  *ngIf="!showNewPassword"
                  src="assets/icons/eye.svg"
                  alt="eye icon"
                />
                <img
                  *ngIf="showNewPassword"
                  src="assets/icons/eye-slash.svg"
                  alt="eye-slash icon"
                />
              </button>
            </div>
            <div
              *ngIf="
                (newPasswordRef.touched || passwordForm.submitted) &&
                newPasswordRef.invalid
              "
              class="text-red-500 text-sm mt-1"
            >
              New password is required
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="w-full md:w-[31%] relative">
            <label
              for="confirmPassword"
              class="block text-sm font-medium text-gray-700 mb-1"
              >{{ "DASHBOARD.SETTINGS.CONFIRM_PASSWORD" | translate }}</label
            >
            <div class="relative">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                name="confirmPassword"
                [(ngModel)]="confirmPassword"
                required
                [disabled]="isOtpSent"
                #confirmPasswordRef="ngModel"
                class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100 disabled:text-gray-500"
              />
              <button
                type="button"
                (click)="togglePasswordVisibility('confirm')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                <img
                  *ngIf="!showConfirmPassword"
                  src="assets/icons/eye.svg"
                  alt="eye icon"
                />
                <img
                  *ngIf="showConfirmPassword"
                  src="assets/icons/eye-slash.svg"
                  alt="eye-slash icon"
                />
              </button>
            </div>
            <div
              *ngIf="
                (confirmPasswordRef.touched || passwordForm.submitted) &&
                confirmPasswordRef.invalid
              "
              class="text-red-500 text-sm mt-1"
            >
              Confirm password is required
            </div>
          </div>
        </div>

        <button
          *ngIf="!isOtpSent"
          type="submit"
          [disabled]="isLoading"
          class="mt-6 px-6 py-2 bg-[#009689] text-white font-semibold rounded-md shadow-md hover:bg-[#00BBA7] focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-75 transition-colors duration-200 disabled:opacity-50"
        >
          <span *ngIf="!isLoading">Send OTP</span>
          <span *ngIf="isLoading">Sending...</span>
        </button>
      </form>

      <div *ngIf="isOtpSent" class="mt-6 border-t pt-6">
        <h3 class="text-gray-700 font-semibold mb-3">Enter OTP</h3>
        <div class="flex flex-wrap items-end gap-4">
          <div class="w-full md:w-1/3">
            <label
              for="otp"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              OTP sent to your registered mobile number
            </label>
            <input
              type="text"
              id="otp"
              name="otp"
              [(ngModel)]="otp"
              [maxLength]="6"
              placeholder="Enter 6-digit OTP"
              class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-teal-500 focus:border-teal-500"
            />
          </div>
          <button
            type="button"
            (click)="onVerifyAndChange()"
            [disabled]="isLoading"
            class="px-6 py-2 bg-[#009689] text-white font-semibold rounded-md shadow-md hover:bg-[#00BBA7] focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-75 transition-colors duration-200 disabled:opacity-50"
          >
            <span *ngIf="!isLoading">Verify & Change Password</span>
            <span *ngIf="isLoading">Verifying...</span>
          </button>
          <div class="mt-2 text-sm">
            <span *ngIf="isTimerActive" class="text-gray-500">
              Resend in {{ resendTimer }}s
            </span>
            <button
              *ngIf="!isTimerActive"
              type="button"
              (click)="onResendOtp()"
              [disabled]="isLoading"
              class="font-medium text-teal-600 hover:text-teal-800 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Resend OTP
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
